import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, Mail, ArrowRight } from 'lucide-react';

export const EmptyClubState = () => {
  return (
    <Card className="max-w-2xl mx-auto text-center">
      <CardHeader>
        <div className="mx-auto w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
          <Users className="w-8 h-8 text-muted-foreground" />
        </div>
        <CardTitle className="text-xl">No Club Memberships Found</CardTitle>
      </CardHeader>
      
      <CardContent className="space-y-6">
        <p className="text-muted-foreground leading-relaxed">
          You don't currently belong to any clubs. To get started, you'll need to be invited 
          by a club administrator or coach.
        </p>
        
        <div className="space-y-4">
          <div className="flex items-start gap-3 text-left">
            <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
              <Mail className="w-3 h-3 text-primary" />
            </div>
            <div>
              <p className="font-medium text-sm">Contact Your Organization</p>
              <p className="text-xs text-muted-foreground">
                Reach out to your club administrator to request access to your team.
              </p>
            </div>
          </div>
          
          <div className="flex items-start gap-3 text-left">
            <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
              <ArrowRight className="w-3 h-3 text-primary" />
            </div>
            <div>
              <p className="font-medium text-sm">Wait for Invitation</p>
              <p className="text-xs text-muted-foreground">
                Once invited, you'll receive an email with instructions to join your club.
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};